import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

import { computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestTypeIcon',
  props: {
    requestType: {}
  },
  setup(__props: any) {

const props = __props

const isRequest = computed(() => {
  return props.requestType == 'request';
})

const isUpload = computed(() => {
  return props.requestType == 'upload';
})

const className = computed(() => {
  if (isUpload.value) return "upload";
  if (isRequest.value) return "request";
  return "";
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isRequest.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          title: _unref(i18n).global.t('pages.cvr_uploads.iconToolTips.request'),
          class: _normalizeClass(["material-symbols-outlined", className.value])
        }, " nest_remote_comfort_sensor ", 10, _hoisted_1))
      : _createCommentVNode("", true),
    (isUpload.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          title: _unref(i18n).global.t('pages.cvr_uploads.iconToolTips.upload'),
          class: _normalizeClass(["material-symbols-outlined", className.value])
        }, " upload ", 10, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})